// extracted by mini-css-extract-plugin
export default {"container":"AddStaff_container__VG5VJ","wrapper-content":"AddStaff_wrapper-content__TRUgH","footer":"AddStaff_footer__kxWX0","button":"AddStaff_button__dIgDo"};